import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

export const TransactionErrors = {
    isLegacy: { id: 0x0001, message: 'Inkomplett/importerad närvaropost, nya arvoden kan inte tas med i transaktionsfil.', short: 'Inkomplett' },
    noPersonalNumber: { id: 0x0002, message: 'Personnummer saknas', short: 'Pnr' },
    noEmployeeNumber: { id: 0x0004, message: 'Anställningsnummer felaktigt/saknas', short: 'Anst.Nr.' },
    noUnitPrice: { id: 0x0008, message: 'à-pris saknas', short: 'à-pris' },
    noAmount: { id: 0x0010, message: 'Belopp saknas', short: 'Belopp' },
    noNumber: { id: 0x0020, message: 'Antal saknas', short: 'Antal' },
    isVacant: { id: 0x0040, message: 'Vakant uppdrag', short: 'Vakant' },
    invalidEmployerCode: { id: 0x0080, message: 'Felaktig arbetsgivarkod', short: 'Arb.kod.' },
    invalidAdministrationCode: { id: 0x0100, message: 'Felaktig förvaltningskod', short: 'Förv.kod.' },
    negativeUnitPrice: { id: 0x0200, message: 'Negativt à-pris', short: 'à-pris' },
    negativeAmount: { id: 0x0400, message: 'Negativt belopp', short: 'Belopp' },
    negativeNumber: { id: 0x0800, message: 'Negativt antal', short: 'Antal' },
    invalidWageTypeCode: { id: 0x1000, message: 'Löneartskod felaktig/saknas', short: 'Kod' },
    invalidAccount: { id: 0x2000, message: 'Konto felaktigt/saknas', short: 'Konto' },
    invalidPersonId: { id: 0x4000, message: 'Person-id i lönesystem saknas', short: 'Person-id' }
};

export const PaymentWarnings = {
    meetingAmount: 1,
    incomeAmount: 2,
    travelCount: 3,
    wageTypeCount: 4,
    getMessage: function (warning) {
        switch (warning) {
            case 1: return 'Max belopp överskridet';
            case 2: return 'Max belopp överskridet';
            case 3: return 'För många arvoden';
            case 4: return 'För många arvoden';
        }
    },
    getLocation: function (warning, wageType) {
        switch (warning) {
            case 1: return 'Mötesarvode';
            case 2: return 'Förlorad inkomst';
            case 3: return 'Km-ersättning';
            case 4: return wageType;
        }
    }
};

class TransactionError {
    /**
     * @param {ResponseContext} ctx
     */
    constructor(src, ctx) {
        _.assign(this, src);
        this.errorList = _.filter(TransactionErrors, x => (this.Error & x.id) != 0);
        this.Person = ctx.getPerson(this.PersonId);
        this.Meeting = ctx.getMeeting(this.MeetingId);
    }
}

class TransactionWarning {
    constructor(src) {
        this.PersonId = src.PersonId;
        this.personName = src.FirstName ? src.FirstName + ' ' + src.LastName : src.LastName;
        this.Date = utility.parseDate(src.Date);
        this.Amount = src.Amount;
        this.Overflow = src.Overflow;
        this.Warning = src.Warning;
        this.message = PaymentWarnings.getMessage(src.Warning);
        this.location = PaymentWarnings.getLocation(src.Warning, src.WageTypeCode + ' ' + src.WageTypeName);
    }
}

class CurrentPaymentRound {
    /**
     * @param {ResponseContext} ctx
     */
    constructor(src, ctx) {
        _.assign(this, src);
        this.PaymentRound = ctx.getPaymentRound(this.PaymentRoundId);
        this.personErrorCount = new Set(_.map(this.Errors, x => x.PersonId)).size;
        this.Errors = _.map(this.Errors, x => new TransactionError(x, ctx));
        this.Warnings = _.map(this.Warnings, x => new TransactionWarning(x));
    }
}

export class WageGroup extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);
        }
        else {
            this.PaymentRoundCutoff = 1;
        }
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        if (this.CurrentRound != null) {
            this.CurrentRound = new CurrentPaymentRound(this.CurrentRound, ctx);
        }
    }

    clone() {
        var src = _.clone(this);
        src.CurrentRound = null;

        var ret = _.cloneDeep(src);
        ret.CurrentRound = this.CurrentRound;
        return ret;
    }
}
